import Grid, { GridProps } from '@mui/material/Grid';
import React from 'react';

type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export type LegacyGridProps = GridProps & {
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  item?: boolean; // ignored
};

const breakpoints: Breakpoint[] = ['xs', 'sm', 'md', 'lg', 'xl'];

const LegacyGrid: React.FC<LegacyGridProps> = ({
  xs,
  sm,
  md,
  lg,
  xl,
  spacing,
  container = false,
  item, // ignored
  ...props
}) => {
  const sizeProps = breakpoints.reduce((acc, key) => {
    const value = { xs, sm, md, lg, xl }[key];
    if (value !== undefined) acc[key] = value;
    return acc;
  }, {} as Partial<Record<Breakpoint, number>>);

  if (container && Object.keys(sizeProps).length === 0) {
    sizeProps.xs = 12;
  }

  const spacingValue = typeof spacing === 'number' ? spacing * 8 : spacing; // MUI uses 8px as the base spacing unit

  return <Grid {...props} {...sizeProps} container={container} spacing={spacingValue} />;
};

export default LegacyGrid;
